import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';

/**
 * Modal asking whether a user wants to rejoin a group they previously
 * left, or continue matching into a different group.
 *
 * Props:
 *   isOpen           - boolean
 *   onClose          - () => void — dismiss (veil, Escape, X); no matching / rejoin side effects
 *   onRejoin         - () => void — confirm rejoin
 *   onFindDifferent  - () => void — skip this candidate / find another group
 *   groupName        - optional string (display name of the offered group)
 */
export default function RejoinModal({ isOpen, onClose, onRejoin, onFindDifferent, groupName }) {
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Rejoin this group?" size="sm">
      <ModalBody>
        <p className="text-ink/80">
          {groupName ? (
            <>
              You previously left <span className="font-semibold text-ink">{groupName}</span>. Would
              you like to rejoin, or find a different group?
            </>
          ) : (
            <>
              Would you like to rejoin your previous group for this event, or find a different
              group?
            </>
          )}
        </p>
      </ModalBody>
      <ModalFooter align="stack">
        <Button fullWidth onClick={onRejoin}>
          Rejoin Group
        </Button>
        <Button
          variant="secondary"
          fullWidth
          onClick={onFindDifferent}
          className="border-primary text-purple-100 hover:bg-primary/20"
        >
          Find a different group
        </Button>
      </ModalFooter>
    </Modal>
  );
}
